import React, { Component } from "react";
import css from "./BrushCursor.module.css";

class BrushCursor extends Component {
  render() {
    let style = {
      cursor: {
        left: this.props.cursorPos[0] - this.props.brush.size / 2,
        top:
          this.props.cursorPos[1] -
          (this.props.brush.size * (this.props.brush.roundness / 100)) / 2,
        width: `${this.props.brush.size}px`,
        height: `${this.props.brush.size *
          (this.props.brush.roundness / 100)}px`,
        transform: `rotate(${-this.props.brush.angle}deg)`
      },
      hardness: {
        width: `calc(${this.props.brush.hardness}% + 2px)`,
        height: `calc(${this.props.brush.hardness}% + 2px)`,
        left: `calc(50% - ${this.props.brush.hardness / 2}% - 1px)`,
        top: `calc(50% - ${this.props.brush.hardness / 2}% - 1px)`
      }
    };
    return (
      <div style={style.cursor} className={css.cursor}>
        {this.props.hardness ? (
          <div style={style.hardness} className={css.hardness} />
        ) : null}
        {this.props.direction ? (
          <div className={css.angle}>
            <div className={css.dot} />
          </div>
        ) : null}
      </div>
    );
  }
}

export default BrushCursor;
